"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListRowSubtitle = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../ListRow/index.js");
var _index2 = require("../ListRowDetails/index.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _logging = require("../../logging.js");
var _excluded = ["id"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * ListRowSubtitle is used as a slot default for ListRow subtitle and can be used to create custom components.
 * The component derives from ListRowDetails and has accessible id functionality when used in ListRow.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-list-listrow-listrowsubtitle--docs) |
 * [Encore site](https://encore.spotify.net/web/components/lists) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/ListRowSubtitle)
 */
var ListRowSubtitle = exports.ListRowSubtitle = /*#__PURE__*/_react["default"].forwardRef(function ListRowSubtitle(_ref, ref) {
  var id = _ref.id,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var parentId = (0, _react.useContext)(_index.ListRowContext);
  var encoreId = parentId ? "listrow-subtitle-".concat(parentId) : undefined;
  if (props.variant) (0, _logging.warnLegacyTypeVariant)('ListRowSubtitle', props.variant, props.weight);
  return /*#__PURE__*/_react["default"].createElement(_index2.ListRowDetails, Object.assign({
    ref: ref,
    id: id || encoreId,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.ListRowSubtitle
  }, props));
});